<template>
  <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="switchClass">
    <div class="bootstrap-switch-container" @click="triggerToggle()">
      <span class="bootstrap-switch-handle-on">
        <slot name="on"> {{ onText }} </slot>
      </span>
      <span class="bootstrap-switch-label"></span>
      <span class="bootstrap-switch-handle-off bootstrap-switch-default">
        <slot name="off"> {{ offText }} </slot>
      </span>
    </div>
  </div>
</template>
<script>
/* eslint-disable vue/require-default-prop */

export default {
  name: 'BaseSwitch',
  props: {
    value: [Array, Boolean],
    onText: String,
    offText: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    switchClass() {
      const base = 'bootstrap-switch-'
      const state = this.model ? 'on' : 'off'
      const classes = base + state
      return classes
    },
    model: {
      get() {
        return this.value
      },
      set(value) {
        if (this.disabled === false) this.$emit('input', value)
      }
    }
  },
  methods: {
    triggerToggle() {
      this.model = !this.model
    }
  }
}
</script>
<style></style>
